import React, { } from 'react';
import './emailmemo.css'; // Import the CSS file
import ChatApiService from '../../services/AxiosServices'
import {useAuth0} from "@auth0/auth0-react";

interface EmailMemoProps {
    message?: any;
    loader?: any;
}
const Emailmemo: React.FC<EmailMemoProps> = ({ message, loader }) => {
    const [isDisabled, setIsDisabled] = React.useState<boolean>(false)
    const {getAccessTokenSilently} = useAuth0();
    const replyHandler = async () => {
        loader(true)
        const formData = new FormData();
        formData.append("user_id", message.user_id);
        formData.append("text", "");
        formData.append("channel_id", message.thread_ts);
        formData.append("thread_ts", message.thread_ts);
        formData.append("button_value","confirm");
        formData.append("chat_provider_name", "INTERNAL_UI");
        formData.append("ts", "test");

        setIsDisabled(true)
        try {
            const token = await getAccessTokenSilently();
            const resp = await ChatApiService.sendChatMessage(formData, token);
            if (resp) {
                loader(false)
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <>
            {message && <div className="container">
                <div className="emailContainer">
                    <div className='emailmemo-title'>
                        {message.text}
                    </div>
                </div>
                {/* <div className="email-footer">
                    <div className='pdfcss-left'>
                        <ul className='confirm'>
                            <li>Document: CitizensNationalBank_investmentmemo.pdf</li>
                            <li>Recipient: John Doe</li>
                            <li>Email: johdoe@gmail.com</li>
                            <li>Task: Send Email</li>
                        </ul>
                    </div>
                </div> */}
                <button className='confirmbt' onClick={replyHandler} disabled={isDisabled} style={{ background: isDisabled ? "gray" : "#008d44" }}>
                    Confirm
                </button>

            </div>}
        </>
    );
};

export default Emailmemo;
